import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "w-100 flex-shrink-1 flex-grow-1 d-flex flex-column container-wide card bg-white",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "d-flex align-items-center flex-wrap p-4" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  class: "w-100 flex-shrink-1 flex-grow-1 font-weight-bold",
  style: {"overflow":"auto"}
}
const _hoisted_5 = { class: "list-row w-100 border-bottom px-4 py-3 mx-0 d-flex flex-row align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "cil-map mr-5",
  style: {"font-size":"40px"}
}, null, -1)
const _hoisted_7 = { class: "mb-0 flex-grow-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "lead mb-0"
}
const _hoisted_11 = { class: "p-inputgroup" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = { class: "mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_translate = _resolveComponent("translate")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Autocomplete = _resolveComponent("Autocomplete")!
  const _component_LeafletMap = _resolveComponent("LeafletMap")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.locationsSWR.call?.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.i18n.$gettext("Standorte")), 1),
      (_ctx.rpcClient.isInternalUser)
        ? (_openBlock(), _createBlock(_component_Checkbox, {
            key: 0,
            modelValue: _ctx.archivedFilter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.archivedFilter) = $event)),
            class: "ml-auto",
            binary: "",
            label: _ctx.i18n.$gettext('Archivierte Standorte')
          }, null, 8, ["modelValue", "label"]))
        : _createCommentVNode("", true),
      (_ctx.rpcClient.isInternalUser)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            icon: "pi pi-plus",
            class: "ml-4",
            label: _ctx.i18n.$gettext('Neuer Standort'),
            onClick: _ctx.createLocation
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_InfiniteList, {
        class: "h-100 w-100",
        "get-all-items": _ctx.locations,
        "id-property": 'id',
        "auto-scroll-at-start": ""
      }, {
        element: _withCtx((props) => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.locationName(props.item)), 1),
            (props.item.isArchived)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.rpcClient.isInternalUser)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-text flat",
                        icon: "pi pi-upload",
                        label: _ctx.i18n.$gettext('Wiederherstellen'),
                        onClick: ($event: any) => (_ctx.unArchiveLocation(props.item))
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.rpcClient.isInternalUser)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-text flat",
                        icon: "pi pi-trash",
                        label: _ctx.i18n.$gettext('Archivieren'),
                        onClick: ($event: any) => (_ctx.archiveLocation(props.item))
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.rpcClient.isInternalUser)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "ml-3",
                        icon: "pi pi-pencil",
                        label: _ctx.i18n.$gettext('Bearbeiten'),
                        onClick: ($event: any) => (_ctx.editLocation(props.item))
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]),
        _: 1
      }, 8, ["get-all-items"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showLocationEditorDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showLocationEditorDialog) = $event)),
      modal: "",
      style: {"min-height":"90vh","max-width":"100vw","width":"600px"},
      onSubmit: _withModifiers(_ctx.save, ["prevent","stop"]),
      onHide: _ctx.closeDialog
    }, {
      header: _withCtx(() => [
        (_ctx.locationToEdit)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              (_ctx.locationToEdit.id)
                ? (_openBlock(), _createBlock(_component_translate, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Standort bearbeiten ")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_translate, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Standort anlegen ")
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Abbrechen'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.closeDialog
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Speichern'),
          icon: "pi pi-check",
          autofocus: "",
          type: "submit",
          disabled: !_ctx.locationToEdit?.latitude || !_ctx.locationToEdit?.name
        }, null, 8, ["label", "disabled"])
      ]),
      default: _withCtx(() => [
        (_ctx.locationToEdit)
          ? (_openBlock(), _createBlock(_component_AnimatedInput, {
              key: 0,
              modelValue: _ctx.locationToEdit.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.locationToEdit.name) = $event)),
              modelModifiers: { lazy: true, trim: true },
              class: "mb-3",
              type: "text",
              label: _ctx.i18n.$gettext('Name'),
              required: ""
            }, null, 8, ["modelValue", "label"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_Autocomplete, {
              class: "w-100",
              "scroll-height": "50vh",
              "force-selection": "",
              modelValue: _ctx.autocompleteInput,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.autocompleteInput) = $event)),
              suggestions: _ctx.locationSuggestions,
              field: "label",
              onComplete: _ctx.updateLocationSuggestions,
              onItemSelect: _ctx.onLocationComplete
            }, null, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect"]),
            _createElementVNode("label", null, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Nach einer Adresse suchen")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_13, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Klicken Sie in der Karte auf den gewünschten Standort und bestätigen Sie Ihre Eingabe dann mit \"Speichern\"")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_LeafletMap, {
          ref: "leafLetMapRef",
          class: "flex-grow-1 h-100 card flat",
          locations: _ctx.locationsToDisplayInMap,
          "only-show-locations": true,
          editmode: true,
          "is-location-selector": true,
          onShapecreate: _ctx.onShapeCreate
        }, null, 8, ["locations", "onShapecreate"])
      ]),
      _: 1
    }, 8, ["visible", "onSubmit", "onHide"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
      _createVNode(_component_Breadcrumb, {
        home: { icon: 'pi pi-home', to: '/' },
        model: _ctx.breadcrumbs
      }, null, 8, ["model"])
    ]))
  ]))
}